import { Config } from 'astra-core/containers/ConfigProvider'

export const getLogoutUrl = (config: Config) => `${config.API_URL}/logout`
